import React from 'react';
import './button-link.scss';

type BottomLinkProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  automationid?: string;
  onClick?: () => void;
};

export default function ButtonLink({
  children,
  className,
  disabled,
  automationid,
  onClick,
}: BottomLinkProps) {
  return (
    <span className="button-link">
      <span
        automationid={automationid}
        onClick={onClick}
        className={`content-normal ${className ? className : ''} ${disabled ? 'disabled' : ''}`}
      >
        {children}
      </span>
    </span>
  );
}

ButtonLink;
